import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';


class Value extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    value: PropTypes.object,
  };

  static defaultProps = {
    children: null,
    value: undefined,
  };

  render() {
    const { children, value } = this.props;

    return (
      <div className="Select-value" title={value?.title}>
        <span className="Select-value-label">
          {children}
        </span>
      </div>
    );
  }
}

export default Value;
